import { type HTMLAttributes } from "react";
import { cn } from "./cn";

/** Pulsing placeholder block for loading states. Size it via `className`. */
export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-muted", className)}
      {...props}
    />
  );
}
